import {
  CONFLICT_ERROR_CODE, FORBIDDEN_ERROR_CODE,
  OverrideReservationGuestError,
  ServiceError
} from '../../model/errors';
import {ServiceErrorMapper} from './service-error.mapper';

export class AssociationErrorMapper extends ServiceErrorMapper {
  map(error: any): ServiceError {
    const serviceError: ServiceError = super.map(error);
    if (serviceError.code === CONFLICT_ERROR_CODE || serviceError.code === FORBIDDEN_ERROR_CODE) {
      return new OverrideReservationGuestError();
    }
    return serviceError;
  }
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/mapper/association-error.mapper.ts